export const VOTE_STATUS = {
  WAITING: undefined,
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
} as const;

export const VOTE_PERIOD = {
  AM: "AM",
  PM: "PM",
} as const;

export const VOTE_ITEM_TYPE = {
  HOT: "HOT",
  COLD: "COLD",
  GOOD: "GOOD",
} as const;

export const ON_OFF_STATUS = {
  ON: "ON",
  OFF: "OFF",
} as const;
